import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rule, AssetManagement, AssetVerify, AssetView, Environment, Zone, Asset } from '@aptsi-types';
import { environment } from '@env';
import { Observable, of } from 'rxjs';
import { catchError, delay, map } from 'rxjs/operators';
import { ErrorHandlingService } from '../../../../shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../../secure-zone-api-endpoints';


interface GetZonesResponse {
  zones: Zone[];
}

interface GetZoneResponse {
  zone: Zone;
}

export interface ZoneMappingRequest {
  securityZoneIds: string[];
  assetIds: string[];
  environmentIds: string[];
  securityZoneId: string;
}

export interface MappingItem {
  id?: string;
  name?: string;
  zoneName?: string;
  assetId?: string;
  assetName?: string;
  description ?: string;
  assetStatus ?: string;
  businessValue ?: string;
  dataClassification ?: string;
   platform ?: string;
}

export interface ZoneMappingsResponse {
  securityZoneId: string;
  environments: MappingItem[];
  assets: MappingItem[];
  securityZones : MappingItem[];
}


@Injectable({
  providedIn: 'root'
})
export class ZoneService {
  private readonly apiUrl = environment.apiUrl;
  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }

  getZones(currentPage: number): Observable<Zone[]> {
    return this.http.post<GetZonesResponse>(`${this.apiUrl}${API_ENDPOINTS.ZONE.FETCH}`, { currentPage })
      .pipe(
        map(response => response.zones),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }
  

  getZone(zoneId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${API_ENDPOINTS.ZONE.GET}`,{zoneId})
      .pipe(
        map(response => response.zone),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }


  getZonesSearch(currentPage: number, searchText: String, filterByHeader: String): Observable<Zone[]> {
    return this.http.post<GetZonesResponse>(`${this.apiUrl}${API_ENDPOINTS.ZONE.SEARCH}`, { currentPage, searchText, filterByHeader })
      .pipe(
        map(response => response.zones),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  createZone(zoneName: string, description: string, securityZoneTypeId:string,platformName:string ,assetType:string, parameterMappings: Zone[]): Observable<any> {
    return this.http.post(`${this.apiUrl}${API_ENDPOINTS.ZONE.CREATE}`, { zoneName, description, securityZoneTypeId, platformName, assetType, parameterMappings })
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  updateZone(zoneId: string, zoneName: string, description: string): Observable<any> {
    return this.http.post(`${this.apiUrl}${API_ENDPOINTS.ZONE.UPDATE}`, { zoneId, zoneName, description})
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
       ); 
  }

  deleteZone(zoneId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}${API_ENDPOINTS.ZONE.DELETE}`, { zoneId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
       ); 
  }

  getSecurityZoneTypes(){
    return this.http.post<any>(`${this.apiUrl}${API_ENDPOINTS.ZONE.GETSECURITYZONETYPES}`,{})
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

    createZoneMappings(payload: ZoneMappingRequest): Observable<any> {
    return this.http
      .post(`${this.apiUrl}${API_ENDPOINTS.ZONE.CREATEZONEMAP}`, {payload})
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  updateZoneMappings(payload: ZoneMappingRequest): Observable<any> {
    return this.http
      .post(`${this.apiUrl}${API_ENDPOINTS.ZONE.UPDATEZONEMAP}`, {payload})
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  // /zone/mappingfetch

  fetchZoneMappings(zoneId:string): Observable<ZoneMappingsResponse> {
    return this.http
      .post<ZoneMappingsResponse>(`${this.apiUrl}${API_ENDPOINTS.ZONE.FETCHZONEMAP}`, {zoneId})
      .pipe(
         map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  
  finishZoneMappings(zoneId:string): Observable<any> {
    return this.http
      .post(`${this.apiUrl}${API_ENDPOINTS.ZONE.FINISHZONEMAP}`, {zoneId})
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

//   getAssetParameters(assetType: string): Observable<any> {

//   const response = assetType === 'DATA'
//     ? {
//         "Resource retrieved successfully": [
//           {
//             id: "1",
//             name: "Sensitivity",
//             values: [
//               "Public",
//               "Internal",
//               "Confidential",
//               "Restricted"
//             ]
//           },
//           {
//             id: "2",
//             name: "Owner",
//             values: []
//           },
//           {
//             id: "3",
//             name: "Region"
//           },
//           {
//             id: "4",
//             name: "Retention",
//             values: [
//               "30 Days",
//               "90 Days",
//               "1 Year"
//             ]
//           }
//         ]
//       }
//     : {
//         "Resource retrieved successfully": [
//           {
//             id: "11",
//             name: "Operating System",
//             values: [
//               "Windows",
//               "Linux",
//               "MacOS"
//             ]
//           },
//           {
//             id: "12",
//             name: "Hostname"
//           },
//           {
//             id: "13",
//             name: "Environment",
//             values: [
//               "DEV",
//               "QA",
//               "UAT",
//               "PROD"
//             ]
//           },
//           {
//             id: "14",
//             name: "Criticality",
//             values: [
//               "High",
//               "Medium",
//               "Low"
//             ]
//           },
//           {
//             id: "15",
//             name: "Application Name",
//             values: []
//           }
//         ]
//       };

//   return of(response).pipe(delay(500)); // simulate API call
// }



getAssetParameters(assetType: string): Observable<Zone[]> {
    return this.http.post<GetZonesResponse>(`${this.apiUrl}${API_ENDPOINTS.SECUREZONEASSET.GETASSETPARAMETERS}`, { assetType }).pipe(
         map(response => response.zones),
        catchError(error => this.errorHandlingService.handleError(error))
      );
}

fetchZoneAssets(zone:Zone): Observable<Zone[]> {
    return this.http.post<GetZonesResponse>(`${this.apiUrl}${API_ENDPOINTS.ZONE.FETCHZONEASSETS}`, { zone })
      .pipe(
        map(response => response.zones),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  getZoneAssetsByZoneId(zoneId: string): Observable<Asset[]> {
    return this.http.post<Asset[]>(`${this.apiUrl}${API_ENDPOINTS.ZONE.GETZONEASSETSBYZONEID}`, { zoneId })
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }


  getPlatformsBySecurityZoneType(
  securityZoneTypeName: string
): Observable<any> {

    return this.http.post<any>(`${this.apiUrl}${API_ENDPOINTS.ZONE.GETPLATFORMSBYSECURITYZONETYPE}`,{ securityZoneTypeName})
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
}

  

}